import __request__ from 'routing/request';
interface TermsVersion {
    readonly date: string;
    readonly text: string;
    readonly version: string;
}
interface Consent {
    readonly cluster_id: string;
    readonly registered_at: string;
    readonly registered_with_server_version: string;
    readonly user_name: string;
    readonly terms_and_conditions_version: string;
}
interface TermsResponse {
    readonly terms: TermsVersion[];
}
interface ConsentsListResponse {
    readonly consents: Consent[];
}
interface TermsAcceptanceResponse {
    readonly terms: TermsVersion;
    readonly acceptance_details: string;
    readonly accepted: boolean;
}
/**
 * Provides details about acceptance status of latest terms version
 */
export function acceptance(): Promise<TermsAcceptanceResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.aiservice/ai/terms/acceptance', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieves all terms and condition of AI investigation summary generation
 */
export function allTerms(): Promise<TermsResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.aiservice/ai/terms/all', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieves all consents of a user invoking this call
 */
export function consents(): Promise<ConsentsListResponse> {
    return __request__('GET', '/plugins/org.graylog.plugins.aiservice/ai/terms/consents', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Accepts terms and condition with certain version for certain user
 */
export function addConsent(terms_and_conditions_version: string): Promise<unknown> {
    return __request__('PUT', `/plugins/org.graylog.plugins.aiservice/ai/terms/consents/${terms_and_conditions_version}`, null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Retrieves latest terms and condition of AI investigation summary generation
 */
export function latestTerms(): Promise<TermsVersion> {
    return __request__('GET', '/plugins/org.graylog.plugins.aiservice/ai/terms/latest', null, {}, {
        'Accept': ['application/json']
    });
}
